export default "__VITE_ASSET__BantMXKa__"